<template>
    <div class="chart-analytics-correctness-periodic">
        <div class="chart-analytics-correctness-periodic__header">
            <span class="chart-analytics-correctness-periodic__header-icon"></span>
            <div class="chart-analytics-correctness-periodic__heading">
                <span class="chart-analytics-correctness-periodic__heading-period">{{ textHeadingPeriod }}</span>
                <span class="chart-analytics-correctness-periodic__heading-text">Genel Doğruluk Gelişimi</span>
            </div>
        </div>
        <div class="chart-analytics-correctness-periodic__wr-chart">
            <div
                v-if="showPreloader"
                class="chart-analytics-correctness-periodic__preloader"></div>
            <canvas
                v-if="!showPreloader"
                id="chart-analytics-correctness-periodic__chart"></canvas>
        </div>
        <div
            v-if="!showPreloader"
            class="chart-analytics-correctness-periodic__legend">
            <span class="chart-analytics-correctness-periodic__legend-icon"></span>
            <span class="chart-analytics-correctness-periodic__legend-text">doğruluk</span>
        </div>
    </div>
</template>
<script>
    import Chart from 'chart.js/auto';
    let chartInstance = null;

    export default {
        data(){
            return {
                showPreloader: true,
            };
        },
        
        computed: {
            filteredChartCorrectnessPeriodicData(){
                if(this.showPreloader){
                    return null;
                }
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsCorrectness.correctnessPeriodic.type;
                return this.$store.state.response.analyticsCorrectness.chartCorrectnessPeriodicData[selectedFiltertagType];
            },

            textHeadingPeriod(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsCorrectness.correctnessPeriodic.type;
                if(selectedFiltertagType === 'weekly'){
                    return 'HAFTALIK';
                }
                else if(selectedFiltertagType === 'monthly'){
                    return 'AYLIK';
                }
                else if(selectedFiltertagType === 'yearly'){
                    return 'YILLIK';
                }
            }
        },

        watch: {
            filteredChartCorrectnessPeriodicData: {
                handler(nv, ov){
                    if(!this.filteredChartCorrectnessPeriodicData){
                        return;
                    }
                    if(!chartInstance){
                        return;
                    }
                    this.$nextTick(() => {
                        chartInstance.destroy();
                        this.createChart();
                    });
                },
                deep: true
            }
        },

        methods: {
            createChart(){
                Chart.defaults.font.family = 'Overpass';
                chartInstance = new Chart(document.querySelector('#chart-analytics-correctness-periodic__chart'), {
                    type: 'line',
                    data: {
                        labels: this.filteredChartCorrectnessPeriodicData.labels,
                        datasets: [{
                            label: 'doğruluk',
                            data: this.filteredChartCorrectnessPeriodicData.data,
                            borderWidth: 2,
                            borderColor: '#2779ED',
                            pointRadius: 2.5,
                            pointBackgroundColor: '#2779ED',
                            cubicInterpolationMode: 'monotone',
                            fill: true,
                            backgroundColor: (context) => {
                                if(!context.chart.chartArea){return;}
                                let chartArea = context.chart.chartArea;
                                let ctx = context.chart.ctx;
                                let gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
                                gradient.addColorStop(0, 'rgba(39, 121, 237, 0.35)');
                                gradient.addColorStop(1, 'rgba(39, 121, 237, 0.05)');
                                return gradient;
                            }
                        }]
                    },
                    options: {
                        maintainAspectRatio: false,
                        scales: {
                            x: {
                                border: {
                                    color: '#A0B8EB',
                                    width: 1,
                                },
                                grid: {
                                    display: false,
                                },
                                ticks: {
                                    color: '#666666',
                                    font: {
                                        size: 11,
                                    }
                                }
                            },
                            y: {
                                border: {
                                    display: false,
                                },
                                grid: {
                                    color: '#CCCCCC',
                                    lineWidth: 1,
                                },
                                ticks: {
                                    color: '#666666',
                                    font: {
                                        size: 11,
                                    },
                                    stepSize: 10,
                                    count: 5,
                                    callback: (tickValue) => {
                                        return '%' + Math.floor(tickValue);
                                    }
                                },
                                beginAtZero: true,
                            }
                        },
                        plugins: {
                            legend: {
                                display: false,
                            },
                            tooltip: {
                                callbacks: {
                                    label: tooltipItem => 'doğruluk %' + tooltipItem.formattedValue
                                }
                            }
                        }
                    }
                });
            }
        },

        mounted(){
            if(this.$store.state.envDev){
                this.showPreloader = true;
                fetch(this.$store.state.jsonServer.analyticsChartCorrectnessPeriodic)
                .then(response => response.json())
                .then(chartCorrectnessPeriodicData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsCorrectness',
                        dataLabel: 'chartCorrectnessPeriodicData',
                        data: chartCorrectnessPeriodicData
                    });
                    this.showPreloader = false;
                    this.$nextTick(() => {
                        this.createChart();
                    });
                });
            }
            else{
                this.showPreloader = true;
                fetch(this.$store.state.api.analyticsCorrectnessChartCorrectnessPeriodic, {
                    method: 'GET',
                    credentials: 'include'
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(chartCorrectnessPeriodicData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsCorrectness',
                        dataLabel: 'chartCorrectnessPeriodicData',
                        data: chartCorrectnessPeriodicData
                    });
                    this.showPreloader = false;
                    this.$nextTick(() => {
                        this.createChart();
                    });
                })
                .catch(err => {
                    this.$foneturkError({
                        text: 'Bir şeyler ters gitti.'
                    });
                    console.error(err);
                });
            }
        }
    };
</script>
<style scoped src="@/css/components/chart-analytics-correctness-periodic.css"></style>